export default __webpack_public_path__ + "static/apple-coreml-e36bf81604be09821f255a708593bcfa.png";